import { render } from "./PrivacyHome.vue?vue&type=template&id=ba40855a&scoped=true&ts=true"
import script from "./PrivacyHome.vue?vue&type=script&lang=ts"
export * from "./PrivacyHome.vue?vue&type=script&lang=ts"

import "./PrivacyHome.vue?vue&type=style&index=0&id=ba40855a&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba40855a"]])

export default __exports__